import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { useSelector, useDispatch } from 'react-redux'
import camelcaseKeys from 'camelcase-keys'
import { Disclosure } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import DateFormat from '../../utils/dateFormat'

import reserveApi from '../../../utils/axios'

import Button from '../../utils/Button'
import { setFlashMessage } from '../../../actions/flashActions'

const Sync = () => {
  const dispatch = useDispatch()
  const facility = useSelector(store => store.facilities.facility)
  const [syncs, setSyncs] = useState([])
  const [syncable, setSyncable] = useState(false)

  useEffect(() => {
    reserveApi.get(`/admin/facilities/${facility.id}/syncs`).then(response => {
      setSyncs(camelcaseKeys(response.data.syncs, { deep: true }))
      setSyncable(response.data.syncable)
    })
  }, [facility])

  const resync = () => {
    reserveApi.post(`/admin/facilities/${facility.id}/resync`).then(response => {
      dispatch(setFlashMessage('Resync in progress.', 'success'))
    })
  }

  return (
    <div className="">
      {syncable && (
        <Button onClick={resync} className="mb-6">
          ReSync
        </Button>
      )}

      {syncs.map(sync => (
        <Disclosure key={sync.id}>
          {({ open }) => (
            <div className="min-h-screen">
              <Disclosure.Button className="border-b-2 border-green-200 px-1 cursor-pointer flex space-x-6">
                <span className="flex-grow text-lg">
                  <DateFormat format="MM/DD/YYYY hh:mm" date={sync.createdAt} />
                </span>

                <span className="flex-grow text-lg">{sync.status}</span>

                <FontAwesomeIcon icon={faChevronRight} className={`${open ? 'transform rotate-90' : ''}`} />
              </Disclosure.Button>

              <Disclosure.Panel>
                <div className="text-xs whitespace-pre-wrap bg-gray-50 p-4">{sync.details?.output}</div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      ))}
    </div>
  )
}

export default Sync
